import { convertToFormData } from 'helper/convert_obj_to_form_data';
import client from './config'

//////////////// contact_us ////////////////
const url = 'contact_us';
export const getContactUsRequest = () => client.get(url);

export const updateContactUsRequest = (values, onUploadProgress) => {
    return client.post(`${url}`, convertToFormData(values), {
        onUploadProgress: (progress) =>
          onUploadProgress((progress.loaded / progress.total) * 100),
      });
}